import React from "react";

const RefreshButton = () => {
  const handleClick = () => {
    window.location.reload(true);
    // console.log("REfresh us clicked !!");
  };

  return (
    <div className=" fixed bottom-0 right-0 h-24 w-[150px] grid place-items-center">
      <button
        className="bg-teal-950 shadow-lg text-white text-lg px-2 py-1 rounded-tl-md rounded-br-md"
        onClick={handleClick}
      >
        Refresh
      </button>
    </div>
  );
};

export default RefreshButton;
